﻿(function () {
    'use strict';

    var serviceId = 'repository.useraccountrequest';

    angular
        .module('app.services')
        .factory(serviceId, useraccountrequest);

    useraccountrequest.$inject = ['common', 'repository.abstract'];
   
    function useraccountrequest(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getCountries = getCountries;
            this.getStatesByCountry = getStatesByCountry;
            this.getCitiesByState = getCitiesByState;
            this.RUTvalidate = RUTvalidate;
            this.RequestRegister = RequestRegister;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getCountries(languageId) {
            languageId = languageId || 2;
            return common.httpGet(config.basePaths.Base_Path_Resources + 'UserAccountRequest/getCountries?languageId=' + languageId);
        }

        function getStatesByCountry(countryId, languageId) {
            languageId = languageId || 2;
            return common.httpGet(config.basePaths.Base_Path_Resources + 'UserAccountRequest/getStatesByCountry?countryId=' + countryId + '&languageId=' + languageId);
        }

        function getCitiesByState(stateId, languageId) {
            languageId = languageId || 2;
            return common.httpGet(config.basePaths.Base_Path_Resources + 'UserAccountRequest/getCitiesByState?stateId=' + stateId + '&languageId=' + languageId);
        }

        function RUTvalidate(RUT) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'UserAccountRequest/RUTvalidate?RUT=' + RUT);
        }

        function RequestRegister(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'UserAccountRequest/RequestRegister', model);
        }
    }
})();